import tippy from 'tippy.js';

class Tooltip {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;

    // get the content
    this.content = element.dataset.tooltipContent;
    this.placement = this.validatePlacement(element.dataset.placement ?? 'top');

    if (this.content) {
      this.init();
    }
  }

  validatePlacement(placement) {
    if (!['top', 'left', 'right', 'bottom'].includes(placement)) {
      return 'top'; // force to the top if we don't recognise the placement
    }

    return placement;
  }

  init() {
    tippy(this.element, {
      content: this.content,
      placement: this.placement,
      animation: 'scale',
      theme: 'translucent',
      interactive: true,
    });
  }
}

export default Tooltip;
